module.exports = __webpack_public_path__ + "img/PCT15.047e87a5.svg";